import { Button, Col, Row } from "react-bootstrap";

export default function WelcomePageSection({ handleSkip, handleContinue }) {
    return (<>
        <h5>Selamat datang di UNITED TRACTORS</h5>

        <p>
            Ayo jelajahi virtual museum dengan
            teknologi. <br /> Kenali dari dekat
            dan pelajari sejarahnya.
        </p>
        <br />
        <Row>
            <Col className='text-center'>
                <Button variant="default-dark" className="w-100" style={{ maxWidth: '180px' }}
                    onClick={e => handleContinue()}
                >
                    Lanjut
                </Button>
            </Col>
        </Row>
        <Row>
            <Col className='text-center' style={{ marginTop: '10px' }}>
                <Button variant="default-dark-outline" className="w-100" style={{ maxWidth: '180px' }}
                    onClick={e => handleSkip()}
                >
                    Skip
                </Button>
            </Col>
        </Row>
    </>)
}